<arm-layout [summaryTitle]="'PROPERTY SUMMARY'">
  <div header>
    <div class="search-container">
      <client-filter (onFilter)="onFilter($event)"></client-filter>
    </div>
    <div class="action-buttons">

      <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                      (editClick)="editItem()" [disableEdit]="isActionDisabled()"
                      (deleteClick)="removeItem()" [disableDelete]="isActionDisabled()"
                      (refreshClick)="refresh()"></arm-action-bar>
    </div>
  </div>

  <div summary>
    <properties-dictionary-summary
      [selection]="selectedItem"
      [attributeOptions]="items">
    </properties-dictionary-summary>
  </div>

  <div main>
    <arm-table [data]="items" (onSelection)="select($event)"
               [displayedColumns]="displayedColumns" [isMultipleSelection]="false"
               [isClientSide]="true" [filter]="filter"></arm-table>
  </div>
</arm-layout>

